export const environment = {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    appVersion: require("../../package.json").version + "-stage",
    production: false,
    baseUrl: "https://loyaltyapi.maxbet.cloud/",

    loyaltyHubUrl: "https://loyalty-api.maxbet.cloud/loyaltyNotificationHub?userid=",
    cateringPurchaseHubUrl: "https://purchase-api.maxbet.cloud/purchaseNotificationHub?userid=",
    spendingHubUrl: "https://spending-api.maxbet.cloud/spendingNotificationHub?userid=",
    bettingPurchaseHubUrl: "https://betting-purchase-api.maxbet.cloud/bettingPurchaseNotificationHub?userid=",
    bettingSpendingHubUrl: "https://betting-spending-api.maxbet.cloud/bettingSpendingNotificationHub?userid=",

    siteKey: "6Lc4DQsqAAAAAAG3MlUgBf3N4IJ8UY2luH_mTVGk",

    localJackpot: { url: "https://demo-jackpot.maxbet.dev/mobile", isActive: false },
    globalJackpotURL: { url: "https://demo-jackpot.maxbet.dev/mobile", isActive: false }
};
